import Phaser from "phaser";
import Pqp from "../../3x1010/Pqp";
import ProgressBar from "./ProgressBar";

export default class CheckOptions extends Phaser.GameObjects.Container {
  constructor(scene, label, callback, adjustx = 0) {
    super(scene);
    this.checked = false;
    this.label = label;
    this.callback = callback;
    this.adjustx = adjustx;
  }

  init(checked = false) {
    this.bigger = this.scene.add.circle(0, 0, 12);
    this.bigger.setStrokeStyle(2, ProgressBar.COLOR_BACK);

    //this.empty = this.scene.add.circle(0, 0, 12, ProgressBar.COLOR_FRONT);
    this.smaller = this.scene.add.circle(0, 0, 4, ProgressBar.COLOR_BACK);
    this.add(this.bigger);
    //this.add(this.empty);
    this.add(this.smaller);
    this.setCheck(checked);

    this.on("pointerdown", this.toggleState.bind(this));

    const wt = 0;
    let txt;
    if (this.label) {
      txt = this.scene.add.text(0, 0, this.label, { fontFamily: "DIN Next LT Pro", fontSize: "24px", color: this.toHexColor(ProgressBar.COLOR_LABELS) });
      txt.setOrigin(0, 0.5);
      this.add(txt);
      this.txt = txt;
      //this.bigger.x = txt.displayWidth - 4 + this.adjustx;
      //this.smaller.x = txt.displayWidth - 4 + this.adjustx;
      //wt = txt.displayWidth + this.adjustx;
    }

    /*this.smaller.x = txt.displayWidth + this.adjustx;
    this.bigger.x = txt.displayWidth + this.adjustx;
    txt.x = 0;*/
    this.smaller.x = -16;
    this.bigger.x = -16;
    txt.x = this.bigger.width - 20; //+ wt; //  this.adjustx;
    //console.log(this.adjustx);

    this.setInteractive({ hitArea: new Phaser.Geom.Rectangle(-ProgressBar.CIRCLE_RADIUS_BIGGER * 2, -ProgressBar.CIRCLE_RADIUS_BIGGER, ProgressBar.CIRCLE_RADIUS_BIGGER * 2 + wt, ProgressBar.CIRCLE_RADIUS_BIGGER * 2), hitAreaCallback: Phaser.Geom.Rectangle.Contains, useHandCursor: true });
  }

  getWidth() {
    if (!this.txt) {
      return 32;
    }
    return this.txt.displayWidth + 32 + this.adjustx;
  }

  setCheck(flag) {
    if (flag) {
      this.checked = true;
      this.smaller.visible = true;
    } else {
      this.checked = false;
      this.smaller.visible = false;
    }
  }

  toggleState() {
    if (this.checked) {
      this.setCheck(false);
    } else {
      this.setCheck(true);
    }
    this.dispatch(CheckOptions.EVENT_CHANGED);
  }

  dispatch(type, data) {
    if (this.callback) {
      const e = { type };
      if (!Pqp.isNullOrEmpty(data)) {
        e.data = data;
      }
      this.callback.call(null, e);
    }
  }

  toHexColor(num) {
    let s = num.toString(16);
    while (s.length < 6) {
      s = "0" + s;
    }
    return "#" + s;
  }
}

CheckOptions.EVENT_CHANGED = "eventChanged";
